module.exports = __webpack_public_path__ + "img/hero-main-2.7b5653a9.png";